import type React from 'react';
import { LoadingSpinner } from '../../shared';
import styles from './QuickPromptsPanel.module.css';

export interface QuickPromptsPanelProps {
  prompts: string[];
  onSelectPrompt: (prompt: string) => void;
  isLoading?: boolean;
  title?: string;
  subtitle?: string;
  agentIcon?: string;
}

export const QuickPromptsPanel: React.FC<QuickPromptsPanelProps> = ({
  prompts,
  onSelectPrompt,
  isLoading = false,
  title = 'Get started',
  subtitle = 'Start a conversation by typing your message.',
  agentIcon,
}) => {
  if (isLoading) {
    return (
      <div className={styles.panel}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.content}>
        <div className={styles.header}>
          {agentIcon && (
            <div className={styles.icon}>
              <img src={agentIcon} alt="" />
            </div>
          )}
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {prompts.length > 0 && (
          <div className={styles.list}>
            {prompts.map((prompt, index) => (
              <button key={index} className={styles.button} onClick={() => onSelectPrompt(prompt)}>
                {prompt}
              </button>
            ))}
          </div>
        )}
      </div>
      <p className={styles.footerHint}>
        You can also explore other assistants in all assistants tab
      </p>
    </div>
  );
};
